const EMPLOYEE_PROMOTION_TABLE_READY = "employeePromotion-table-ready"
const SEARCH_TEXT_STATE = "employeePromotion-table-search-text-state"
const ROWS_PER_PAGE_STATE = "employeePromotion-table-rows-per-page-state"
const PAGINATION_STATE = "employeePromotion-table-pagination-state"

const EMPLOYEE_PROMOTION_ID_FOR_ACTION = "employeePromotion-table-employee-promotion-id-for-action"

const ADD_EMPLOYEE_PROMOTION_READY = "eemployeePromotion-table-add-employee-promotion-ready"

const PREVIOUS_EMPLOYEE_PROMOTION_FILTER_CITY = "previous-employee-promotion-filter-city"

const PREVIOUS_EMPLOYEE_PROMOTION_FILTER_KITCHEN_ID = "previous-employee-promotion-filter-kitchen-id-action"

const PREVIOUS_EMPLOYEE_PROMOTION_FILTER_START_DATE= "previous-employee-promotion-filter-start-date"
const PREVIOUS_EMPLOYEE_PROMOTION_FILTER_END_DATE= "previous-employee-promotion-filter-end-date"



const initialState = {
    isEmployeePromotionTableReady: true,
    isAddEmployeePromotionReady:true,
    employeePromotion: {},
    
    employeePromotionSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterKitchenId : "",
    previousFilterStartDate : "",
    previousFilterEndDate : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEE_PROMOTION_TABLE_READY:
            return Object.assign({}, state, { isEmployeePromotionTableReady: action.payload })
        case ADD_EMPLOYEE_PROMOTION_READY:
            return Object.assign({}, state, { isAddEmployeePromotionReady: action.payload })


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case EMPLOYEE_PROMOTION_ID_FOR_ACTION:
            return Object.assign({}, state, {employeePromotionSelectedId:action.payload})

        case PREVIOUS_EMPLOYEE_PROMOTION_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_EMPLOYEE_PROMOTION_FILTER_KITCHEN_ID:
            return Object.assign({}, state, {previousFilterKitchenId:action.payload})

        case PREVIOUS_EMPLOYEE_PROMOTION_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})

        case PREVIOUS_EMPLOYEE_PROMOTION_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function employeePromotionTableReady(data) {
    return {
        type: EMPLOYEE_PROMOTION_TABLE_READY,
        payload: data
    }
}


export function addEmployeePromotionReady(data) {
    return {
        type: ADD_EMPLOYEE_PROMOTION_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function employeePromotionIdForAction(employeePromotionId){
    return{
        type:EMPLOYEE_PROMOTION_ID_FOR_ACTION,
        payload:employeePromotionId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PROMOTION_FILTER_CITY,
        payload:filterVal
    }
}


export function previousFilterKitchenId(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PROMOTION_FILTER_KITCHEN_ID,
        payload:filterVal
    }
}


export function previousFilterStartDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PROMOTION_FILTER_START_DATE,
        payload:filterVal
    }
}


export function previousFilterEndDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PROMOTION_FILTER_END_DATE,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Employee Promotion/redux/employee_promotion.js